"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = require("@Components/Buttons/Button");
const react_1 = __importStar(require("react"));
const permissions_1 = require("@Const/permissions");
const ViewWorkHeader_1 = __importDefault(require("@Components/ViewWork/Headers/ViewWorkHeader"));
const PermissionCheck_1 = __importDefault(require("@Components/PermissionCheck"));
const get_source_name_by_source_id_1 = require("@App/helpers/work-entities/utils/get-source-name-by-source-id");
const get_latest_updated_date_1 = require("@App/helpers/work-entities/utils/get-latest-updated-date");
const react_router_dom_1 = require("react-router-dom");
const contexts_1 = require("@App/contexts");
const can_member_edit_1 = require("@App/helpers/can-member-edit");
const is_overclaim_allowed_1 = require("@App/helpers/is-overclaim-allowed");
const CatalogWorkHeader = (props) => {
    var _a, _b, _c;
    const { work, editOnClick, claimOnClick } = props;
    const { userStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const location = (0, react_router_dom_1.useLocation)();
    const isEditable = (0, react_1.useMemo)(() => (0, can_member_edit_1.canMemberEdit)(work, rightsholderStore.currentRightsholderId) || userStore.isInternal, [work, rightsholderStore.currentRightsholderId, userStore.isInternal]);
    return (react_1.default.createElement(ViewWorkHeader_1.default, { work: work, backText: '< Back to results' },
        react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.manage_works], orIsInternal: true },
            react_1.default.createElement("div", { className: 'metadata-button-wrapper' },
                !((_a = location.state) === null || _a === void 0 ? void 0 : _a.claimType) && isEditable ? (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary-small', onClick: editOnClick }, "Edit")) : (((0, is_overclaim_allowed_1.isOverclaimAllowed)(work) || work.totalKnownShares < 100) && (react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary-small', onClick: claimOnClick }, "Claim shares on this work"))),
                react_1.default.createElement("div", { className: 'metadata' }, (work === null || work === void 0 ? void 0 : work.lastUpdated) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: 'last-updated' },
                        "Last Edited:",
                        ' ', (_c = (_b = (0, get_latest_updated_date_1.getLatestUpdateDate)(work)) === null || _b === void 0 ? void 0 : _b.toLocaleString('en', {
                        year: 'numeric',
                        month: 'long',
                        day: '2-digit',
                    })) !== null && _c !== void 0 ? _c : 'Unknown'),
                    react_1.default.createElement("div", { className: 'updated-by' },
                        "Source: ",
                        (0, get_source_name_by_source_id_1.getSourceNameBySourceId)(work === null || work === void 0 ? void 0 : work.sourceId)))))))));
};
exports.default = CatalogWorkHeader;
